import { render, staticRenderFns } from "./AuthorMobileMenu.vue?vue&type=template&id=1b1b0b62"
import script from "./AuthorMobileMenu.vue?vue&type=script&lang=js"
export * from "./AuthorMobileMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports